export const affiliatePortalRoutes = {
  default: 'affiliate-gamification-frame',
  dashboard: 'affiliate-dashboard-frame',
  about: 'affiliate-about-frame',
  termsAndConditions: 'affiliate-terms-and-conditions-frame',
  tipalti:{
    paymentDetails:'affiliate-tipalti-payment-details-frame',
    paymentHistory:'affiliate-tipalti-payment-history-frame',
    invoiceHistory: 'affiliate-tipalti-invoice-history-frame',
  }
}
